/**
 * Dialog s informacemi o aplikaci.
 */
import React from "react";
import { Button, CardBody, Col, Row } from "reactstrap";
import { form, MCIcon } from "@mc/mc-legacy";
import "./OAplikaci.scss";
export function OAplikaci(props) {
  function renderActions() {
    return (
      <Button type="button" onClick={props.onClose}>
        Zavřít
      </Button>
    );
  }

  return (
    <div id="o-aplikaci-warpper">
      <CardBody>
        <Row noGutters className="mt-3">
          <Col
            xs={{
              size: 12,
            }}
            sm={{
              size: 2,
            }}
          >
            <div className="icon-about">
              <MCIcon icon="qsign" size="3x" />
            </div>
          </Col>
          <Col
            xs={{
              size: 12,
            }}
            sm={{
              size: 10,
            }}
          >
            <Row>
              <Col>
                <h2>QSign</h2>
              </Col>
            </Row>
            <Row>
              <Col>
                <h3>{appVersion}</h3>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <p>© 2019 MARBES CONSULTING s.r.o</p>
          </Col>
        </Row>
      </CardBody>
      <form.FormActions onClose={props.onClose} closeButton />
    </div>
  );
}
